import { isModalOpen } from 'shared/store/modal/modalGetterTypes';
import { clearFormData } from 'shared/stores/form/formMutationTypes';
import { API_KEY_CREATE_FORM } from 'web/form/formKeys';
import { openModal, closeModal } from 'shared/store/modal/modalMutationTypes';
import {
  showApiKeyCreateModal,
  showApiKeyRevealModal,
  showApiKeyRevokeModal,
  revealedApiKey,
  revokeTargetApiKey,
} from 'web/apiKey/apiKeyGetterTypes';
import {
  setRevealedApiKey,
  setRevokeTargetApiKey,
} from 'web/apiKey/apiKeyMutationTypes';
import {
  API_KEY_CREATE_MODAL,
  API_KEY_REVEAL_MODAL,
  API_KEY_REVOKE_MODAL,
} from 'web/modal/modalKeys';
import {
  openApiKeyCreateModalAction,
  openApiKeyRevealModalAction,
  closeApiKeyRevealModalAction,
  openApiKeyRevokeModalAction,
  closeApiKeyRevokeModalAction,
} from 'web/apiKey/apiKeyActionTypes';

export default {
  state: {
    // The one-time created key (incl. raw secret), held only while the reveal modal is open.
    revealedApiKey: null,
    // The key currently targeted for revocation, held only while the confirm modal is open.
    revokeTargetApiKey: null,
  },
  getters: {
    [showApiKeyCreateModal](state, getters, rootState, rootGetters) {
      return rootGetters[isModalOpen](API_KEY_CREATE_MODAL);
    },
    [showApiKeyRevealModal](state, getters, rootState, rootGetters) {
      return rootGetters[isModalOpen](API_KEY_REVEAL_MODAL);
    },
    [showApiKeyRevokeModal](state, getters, rootState, rootGetters) {
      return rootGetters[isModalOpen](API_KEY_REVOKE_MODAL);
    },
    [revealedApiKey](state) {
      return state.revealedApiKey;
    },
    [revokeTargetApiKey](state) {
      return state.revokeTargetApiKey;
    },
  },
  mutations: {
    [setRevealedApiKey](state, apiKey) {
      state.revealedApiKey = apiKey;
    },
    [setRevokeTargetApiKey](state, apiKey) {
      state.revokeTargetApiKey = apiKey;
    },
  },
  actions: {
    [openApiKeyCreateModalAction]({ commit }) {
      commit(clearFormData, API_KEY_CREATE_FORM);
      commit(openModal, API_KEY_CREATE_MODAL);
    },
    [openApiKeyRevealModalAction]({ commit }, apiKey) {
      commit(setRevealedApiKey, apiKey);
      commit(openModal, API_KEY_REVEAL_MODAL);
    },
    [closeApiKeyRevealModalAction]({ commit }) {
      commit(closeModal, API_KEY_REVEAL_MODAL);
      // Discard the secret from memory once the modal is dismissed.
      commit(setRevealedApiKey, null);
    },
    [openApiKeyRevokeModalAction]({ commit }, apiKey) {
      commit(setRevokeTargetApiKey, apiKey);
      commit(openModal, API_KEY_REVOKE_MODAL);
    },
    [closeApiKeyRevokeModalAction]({ commit }) {
      commit(closeModal, API_KEY_REVOKE_MODAL);
      commit(setRevokeTargetApiKey, null);
    },
  },
};
